<template lang="pug">
#tabela-infos-pep-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )
    div(v-if='Object.keys(dados).length > 0')
        BaseInfoBlock(
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.pep.funcao"), $t("mensagens.preAnaliseCredito.pep.orgao"), $t("mensagens.preAnaliseCredito.pep.nivel")]',
            :valores-info-block='[dados.funcao, dados.orgao, dados.pessoaPEPNivelPrincipal]'
        )
        el-divider
        BaseInfoBlock(
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.pep.dataInclusao"), $t("mensagens.preAnaliseCredito.pep.dataFinalCarencia"), $t("mensagens.preAnaliseCredito.pep.dataDaExoneracao")]',
            :valores-info-block='[mxFormatarData(dados.dataInicioExercicio), mxFormatarData(dados.dataFimCarencia), mxFormatarData(dados.dataFimExercicio)]'
        )
        el-divider
        BaseInfoBlock(
            v-if='dados.primarios',
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.pep.pepPrimario"), $t("mensagens.preAnaliseCredito.pep.relacionado"), $t("mensagens.preAnaliseCredito.pep.relacao")]',
            :valores-info-block='[dados.primarios.funcao, dados.primarios.nome, dados.primarios.relacao]'
        )
        BaseInfoBlock(
            v-else,
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.pep.pepPrimario"), $t("mensagens.preAnaliseCredito.pep.relacionado"), $t("mensagens.preAnaliseCredito.pep.relacao")]',
            :valores-info-block='["--", "--", "--"]'
        )
    el-alert(
        v-else,
        :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${tituloTabela}`',
        type='warning',
        :closable='false'
    )
</template>

<script>
import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';
import BaseInfoBlock from '@/modules/pre-analise-credito/components/BaseInfoBlock';

export default {
    name: 'TabelaPepPf',

    components: {
        BaseTableHeader,
        BaseInfoBlock
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-account-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    }
};
</script>

<style lang="scss">
#tabela-infos-pep-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .table-infos-profissionais {
        height: 100%;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }
}
</style>
